import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts'
import { type GHLDailyStats, calculateTotalCost } from '@/lib/ghl-dashboard'

interface Props {
  readonly data: GHLDailyStats[]
}

export function DailyCostChart({ data }: Props) {
  if (data.length === 0) {
    return (
      <Card>
        <CardHeader><CardTitle className="text-sm font-medium">Daily AI Cost</CardTitle></CardHeader>
        <CardContent>
          <div className="flex items-center justify-center h-48 text-sm text-muted-foreground">No data for selected period</div>
        </CardContent>
      </Card>
    )
  }

  const formatted = data.map((d) => ({
    date: new Date(d.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
    cost: Number(calculateTotalCost(d.input_tokens, d.output_tokens).toFixed(4)),
  }))

  return (
    <Card>
      <CardHeader><CardTitle className="text-sm font-medium">Daily AI Cost</CardTitle></CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={240}>
          <AreaChart data={formatted}>
            <defs>
              <linearGradient id="costGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="hsl(45, 93%, 47%)" stopOpacity={0.3} />
                <stop offset="95%" stopColor="hsl(45, 93%, 47%)" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
            <XAxis dataKey="date" tick={{ fontSize: 12 }} />
            <YAxis tick={{ fontSize: 12 }} tickFormatter={(v: number) => `$${v.toFixed(2)}`} />
            <Tooltip formatter={(value: number) => [`$${value.toFixed(4)}`, 'Cost']} />
            <Area type="monotone" dataKey="cost" stroke="hsl(45, 93%, 47%)" fill="url(#costGradient)" strokeWidth={2} />
          </AreaChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  )
}
